<template>
  <vs-popup
    class="show-existing-rm-orders-popup"
    id="popup"
    title="EXISTING RM ORDERS"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <div v-if="orders.length > 0">
        <vs-table
          :max-items="10"
          :data="orders"
          stripe
          class="table-dark-inverted vs-con-loading__container"
        >
          <template slot="thead">
            <vs-th>PO CODE</vs-th>
            <vs-th>CREATED DATE</vs-th>
            <vs-th>STATUS</vs-th>
            <vs-th> QTY</vs-th>
            <vs-th>SUPPLIER</vs-th>
            <vs-th>ACTION</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].order_code">
                {{ data[indextr].order_code }}
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
              </vs-td>

              <vs-td :data="data[indextr].item_status">
                {{ data[indextr].item_status }}
              </vs-td>
              <vs-td :data="data[indextr].quantity">
                {{ data[indextr].quantity }}
              </vs-td>
              <vs-td :data="data[indextr].supplier">
                {{ data[indextr].supplier }}
              </vs-td>

              <vs-td>
                <div class="flex">
                  <vx-tooltip text="View Order Details" position="top">
                    <vs-button
                      @click.stop="viewOrderDetails(data[indextr].id)"
                      size="small"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div v-else>
        <p>No existing RM orders found.</p>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button
          @click="closePopup"
          button="submit"
          color="danger"
          class="ml-auto mt-2"
          >Close</vs-button
        >
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import vSelect from "vue-select";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

const InventoryRepository = RepositoryFactory.get("inventory");

function initialState() {
  return {
    open: false,
    orders: [],
    id: null,
  };
}

export default {
  name: "ShowExistingRmOrdersPopUp",
  data() {
    return initialState();
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.id = id;
        await this.getExistingRmOrders();
      } catch (error) {}
    },
    async getExistingRmOrders() {
      this.$vs.loading();
      try {
        const response = await InventoryRepository.getRmOutstandingOrders(
          this.id
        );
        this.orders = response.data.data || response.data;
        this.open = true;
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    closePopup() {
      this.open = false;
    },
    formatDate(date) {
      if (!date) return "N/A";
      return new Date(date).toLocaleString();
    },
    viewOrderDetails(orderId) {
      const route = this.$router.resolve({
        path: `/pages/raw-materials/orders/${orderId}`,
      });
      window.open(route.href, "_blank");
    },
  },
  components: {
    "v-select": vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
};
</script>

<style scoped>
.show-existing-rm-orders-popup >>> .vs-popup {
  min-width: 80% !important;
}
</style>
